module.exports = __webpack_public_path__ + "media/images/icons/outlined/property-safety-ca0c4f58809e817cb1583ef86a24546f.svg";